var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"livevideobox"},[_c('div',{ref:"J_prismPlayer",staticClass:"prism-player",attrs:{"id":"J_prismPlayer"}})])}
var staticRenderFns = []

export { render, staticRenderFns }